//Variables
const cookieProducts = 'rechargebundle_products';
const money = new Intl.NumberFormat(window.Shopify.country, {
  style: 'currency',
  currency: window.Shopify.currency.active
});

document.addEventListener("DOMContentLoaded", (e) => {
  const configuration = document.querySelector(".rb-configuration")
  const observer = new IntersectionObserver(([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1), { threshold: [1] });
  observer.observe(configuration);

  (function syncAnnouncementBarHeight() {
    const BAR_IDS = ["#qab_background", "#qab_bar", "#qab_container"];
    const setHeight = () => {
      let h = 0;
      for (const sel of BAR_IDS) {
        const el = document.querySelector(sel);
        if (!el) continue;
        const s = getComputedStyle(el);
        const r = el.getBoundingClientRect();
        if ((s.position === "fixed" || s.position === "sticky") && r.top <= 1 && r.height > 0) {
          h = Math.max(h, Math.round(r.height));
        }
      }
      document.documentElement.style.setProperty("--qab-height", h + "px");
      document.body.classList.toggle("has-announcement-bar", h > 0);
    };
    const ro = "ResizeObserver" in window ? new ResizeObserver(setHeight) : null;
    const observed = new Set();
    const attach = () => {
      setHeight();
      if (!ro) return;
      for (const sel of BAR_IDS) {
        const el = document.querySelector(sel);
        if (el && !observed.has(el)) { observed.add(el); ro.observe(el); }
      }
    };
    attach();
    window.addEventListener("resize", setHeight);
    if ("MutationObserver" in window) {
      const mo = new MutationObserver(() => {
        attach();
        if (document.querySelector("#qab_background")) mo.disconnect();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  class RechargeVariantButton extends HTMLElement {
    connectedCallback() {
      document.addEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.addEventListener('recharge:progress', this.onProgressChange.bind(this));
      this.addEventListener("click", this.onClickHandler.bind(this));
    }
    
    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.removeEventListener('recharge:progress', this.onProgressChange.bind(this));
    }

    onRechargeReady() {
      this.addEventListener('click', this.onClick.bind(this));

      setTimeout(() => {
        this.updateSelect();
        this.hidden = false;

        //Check for Variants in URL
        this.updateVariantByUrl();
      }, 100)
    }

    onProgressChange(event) {
      const { value } = event.detail;
      this.disabled = value > this.meal
    }

    onClickHandler(event){
      this.setVariantURL(this.variantTitle);
    }

    setVariantURL(title){
      const params = new URLSearchParams(window.location.search);
      params.set('variant', title);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
    }

    updateVariantByUrl() {
      const params = new URLSearchParams(window.location.search);
      const variant = params.get('variant');

      if(!variant) {
        return;
      }

      const target = document.querySelector(`rb-button[data-variant-title="${variant}"]`);
      if(!target || target.hasAttribute('active')) {
        return;
      }

      target.click();
    }

    get title() {
      return this.getAttribute('title')
    }

    get variantTitle() {
      return this.getAttribute('data-variant-title') || this.title
    }

    get percentage() {
      return this.getAttribute('percentage')
    }

    get price() {
      return this.getAttribute('price')
    }

    get disabled() {
      return this.hasAttribute('disabled')
    }

    set disabled(value) {
      return value ? this.setAttribute('disabled', true) : this.removeAttribute('disabled')
    }
    
    get meal() {
      return Number(this.variantTitle.replace(/[^0-9.-]+/g, ''))
    }

    get values() {
      return {
        id: this.id,
        title: this.title,
        variantTitle: this.variantTitle,
        price: this.price,
        percentage: this.percentage,
      }
    }

    get active() {
      return this.getAttribute('active') ? true : false
    }

    set active(flag) {
      if(flag) {
        this.setAttribute('active', true)
      } else {
        this.removeAttribute('active');
      }
    }

    get hidden() {
      return this.getAttribute('hidden') ? true : false
    }

    set hidden(flag) {
      if(flag) {
        this.setAttribute('hidden', true)
      } else {
        this.removeAttribute('hidden');
      }
    }

    updateSelect() {
      const select = document.querySelector('#product-variant-list');
      const button = document.querySelector('rb-button[active]');
      if(!select || !button) {
        return;
      }
      
      //Set Value based on Title
      const option = [...select.options].find(o => o.value === button.variantTitle);
      if(!option) {
        return console.error('RechargeVariantButton', 'no matching variant option', button.variantTitle);
      }

      select.value = option.value;

      //Dispatch Event for Recharge
      select.dispatchEvent(new Event('change'));
    }

    onClick(e) {
      if(this.active || this.disabled) {
        return;
      }

      //Dispatch Global Event
      this.dispatchEvent();

      //Update buttons
      this.variants = document.querySelectorAll('rb-button');
      this.variants.forEach((variant) => (variant.active = false));

      this.active = !this.active

      //Update Select
      this.updateSelect();
    }

    dispatchEvent() {
      document.dispatchEvent(new CustomEvent('recharge:variant', {
        detail: this.values
      }))
    }
  }
  customElements.define('rb-button', RechargeVariantButton);

  class RechargeDelivery extends HTMLElement {
    connectedCallback() {
      document.addEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.addEventListener("recharge:progress", this.onProgressChange.bind(this));
      document.addEventListener("recharge:variant", this.onVariantChange.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.removeEventListener("recharge:progress", this.onProgressChange.bind(this));
      document.removeEventListener("recharge:variant", this.onVariantChange.bind(this));
    }

    onRechargeReady() {
      this.hidden = false;

      if(this.checkbox) {
        this.checkbox.removeEventListener('click', this.onCheckbox.bind(this));  
      }
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.checkbox.addEventListener('click', this.onCheckbox.bind(this));

      if(this.switches) {
        this.switches.forEach(element => element.removeEventListener('click', this.onSwitch.bind(this)));  
      }
      this.switches = this.querySelectorAll('[for="rb-configuration-delivery"]');
      this.switches.forEach(element => element.addEventListener('click', this.onSwitch.bind(this)));

      if(this.select) {
        this.select.removeEventListener('change', this.onSelectChange.bind(this));
      }
      this.select = this.querySelector('select');
      this.select.addEventListener('change', this.onSelectChange.bind(this));

      setTimeout(() => {
        //Restore saved delivery config
        this.restoreFromStorage();

        // Apply the active variant's `custom.recharge_preselect` on initial load.
        this.onVariantChange();
      }, 100)
    }

    onVariantChange() {
      // Recharge widget processes the variant change asynchronously (Vue.js)
      // and may reset the selling plan to its default for the new variant.
      // Delay so our action lands AFTER Recharge has finished, not before.
      clearTimeout(this._preselectTimer);
      this._preselectTimer = setTimeout(() => {
        // Honor the current subscription toggle. If the user toggled OFF in
        // the 500ms after switching variants, we must not overwrite that
        // with a subscription preselect.
        if (!this.active) {
          this.applyOneTime();
          return;
        }
        const active = document.querySelector('rb-button[active]');
        if (!active) return;
        const preselect = active.getAttribute('data-recharge-preselect');
        this.applyPreselect(preselect);
      }, 500);
    }

    get rechargeCheckbox() {
      return document.querySelector('.rb-subscribe-and-save-container .rb-switch input');
    }

    get rechargeSelect() {
      return document.querySelector('.rb-frequency select');
    }

    applyPreselect(preselect) {
      if (!preselect) return;

      // Update the local select (in our configuration bar) by matching option text.
      if (this.select) {
        const localOpt = this.findPlanOption(this.select, preselect);
        if (localOpt) {
          this.select.selectedIndex = localOpt.index;
        }
      }

      this.enableRechargeSubscription(() => this.applyPlan(preselect));
      this.saveToStorage();
    }

    enableRechargeSubscription(done) {
      const checkbox = this.rechargeCheckbox;
      if (checkbox && !checkbox.checked) {
        checkbox.click();
        setTimeout(done, 200);
        return;
      }
      done();
    }

    applyPlan(preselect) {
      // Match by option text — Recharge's option set differs from our local one.
      const select = this.rechargeSelect;
      if (!select) return;
      const rechargeOpt = this.findPlanOption(select, preselect);
      if (!rechargeOpt) return;
      select.selectedIndex = rechargeOpt.index;
      select.dispatchEvent(new Event('change'));
    }

    findPlanOption(select, name) {
      const options = [...select.querySelectorAll('option')];
      const exact = options.find(o => (o.dataset.planName || o.textContent).trim() === name);
      if (exact) return exact;

      const weeks = this.planWeeks(name);
      if (!weeks) return null;
      if (weeks > 1) {
        return options.find(o => this.planWeeks(o.textContent) === weeks) || null;
      }

      const numbered = options.findIndex(o => /\d/.test(o.textContent));
      if (numbered > 0) return options[numbered - 1];
      return options[0] || null;
    }

    planWeeks(text) {
      const label = (text || '').trim();
      if (!label) return 0;
      const n = parseInt(label.match(/\d+/)?.[0], 10);
      return Number.isFinite(n) ? n : 1;
    }

    applyOneTime() {
      const checkbox = this.rechargeCheckbox;
      if (checkbox) {
        if (checkbox.checked) {
          checkbox.click();
        }
        return;
      }

      // v2: "Nur einmalig" is the first option; selecting it makes the widget
      // drop the selling_plan from the cart payload.
      const select = this.rechargeSelect;
      if (!select) return;
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change'));
    }

    get active() {
      return this.getAttribute('active') ? true : false
    }

    set active(flag) {
      if(flag) {
        this.setAttribute('active', true)
        this.select.removeAttribute('hidden');
      } else {
        this.removeAttribute('active');
        this.select.hidden = true
      }
    }

    get hidden() {
      return this.getAttribute('hidden') ? true : false
    }

    set hidden(flag) {
      if(flag) {
        this.setAttribute('hidden', true)
      } else {
        this.removeAttribute('hidden');
      }
    }

    updateSelect() {
      const select = this.rechargeSelect;
      if(!select || !this.select) {
        return;
      }

      // Match by option text — local and Recharge selects have different
      // option counts (Recharge has "Nur einmalig" at index 0), so index-mapping
      // would point to the wrong selling plan.
      const localOpt = this.select.options[this.select.selectedIndex];
      if (!localOpt) return;
      const name = (localOpt.dataset.planName || localOpt.textContent).trim();
      const rechargeOpt = this.findPlanOption(select, name);
      if (!rechargeOpt) return;

      select.selectedIndex = rechargeOpt.index;
    }

    saveToStorage() {
      Shopify.LocalStorage.set('rechargebundle_delivery', {
        active: this.active,
        frequency: this.select.value,
        timestamp: Date.now(),
      });
    }

    restoreFromStorage() {
      const saved = Shopify.LocalStorage.get('rechargebundle_delivery');
      if(!saved) return;

      //Make sure its not older than 5 Minutes
      if(Date.now() - saved.timestamp > 5 * 60 * 1000) {
        Shopify.LocalStorage.remove('rechargebundle_delivery');
        return;
      }

      // Restore visual state of the local toggle.
      this.active = !!saved.active;
      this.checkbox.checked = !!saved.active;

      if (saved.active) {
        if (saved.frequency) {
          this.select.value = saved.frequency;
        }
        // Sync the chosen frequency to Recharge's selling-plan-list by text.
        this.enableRechargeSubscription(() => this.updateSelect());
      } else {
        // Saved state was one-time → tell Recharge to use "Nur einmalig".
        this.applyOneTime();
      }
    }

    onCheckbox() {
      this.active = this.checkbox.checked;
      // Cancel any pending preselect timer from a recent variant change so
      // it can't fire after this toggle and undo us.
      clearTimeout(this._preselectTimer);
      this.applySubscriptionState();
      this.saveToStorage();
      this.dispatchEvent();
    }

    onSwitch() {
      this.active = !this.active;
      this.checkbox.checked = this.active;
      clearTimeout(this._preselectTimer);
      this.applySubscriptionState();
      this.saveToStorage();
      this.dispatchEvent();
    }

    applySubscriptionState() {
      if (this.active) {
        // Toggle ON → re-apply the active variant's preselect (or current local select).
        const activeBtn = document.querySelector('rb-button[active]');
        const preselect = activeBtn?.getAttribute('data-recharge-preselect');
        if (preselect) {
          this.applyPreselect(preselect);
        } else {
          this.enableRechargeSubscription(() => this.updateSelect());
        }
      } else {
        // Toggle OFF → tell Recharge to use one-time.
        this.applyOneTime();
      }
    }

    onSelectChange(event) {
      // User picked a frequency in the local select — mirror to Recharge by text.
      this.updateSelect();
      const select = this.rechargeSelect;
      if (select) {
        select.dispatchEvent(new Event('change'));
      }
      this.saveToStorage();
    }

    onProgressChange() {
      // Only sync local→Recharge when subscription is on. Otherwise the user
      // toggled "one-time" and we must NOT overwrite Recharge's "Nur einmalig"
      // selection with whatever frequency the local select still happens to show.
      if (this.active) {
        this.updateSelect();
      }
    }

    dispatchEvent() {
      document.dispatchEvent(new CustomEvent('recharge:delivery', {
        detail: {
          id: this.id,
          title: this.title,
          price: this.price
        }
      }))
    }
  }
  customElements.define('rb-delivery', RechargeDelivery);

  class RechargeFilters extends HTMLElement {
    connectedCallback() {
      this.amount = 0;
      this.actives = null;
      this._boundReady = this.onRechargeReady.bind(this);
      this._boundOpenFilter = this.openFilter.bind(this);
      this._boundActivateFilter = this.activateFilter.bind(this);
      this._boundOnChange = this.onChange.bind(this);
      this._innerListenersAttached = false;
      this.recharge = {
        filters: null,
        button: null,
      }

      document.addEventListener("bundling-widget:ready", this._boundReady);
    }

    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this._boundReady);

      if (this.button) this.button.removeEventListener('click', this._boundOpenFilter);
      if (this.filters) this.filters.forEach(filter => filter.removeEventListener('click', this._boundActivateFilter));
    }

    onRechargeReady() {
      if (!this._innerListenersAttached) {
        this.button = this.querySelector('[data-open]');
        this.button.addEventListener('click', this._boundOpenFilter);

        this.filters = this.querySelectorAll('[data-filter]');
        this.filters.forEach(filter => filter.addEventListener('click', this._boundActivateFilter));

        this._innerListenersAttached = true;
      }

      setTimeout(() => {
        const configurator = document.querySelector('.rb-configuration');
        configurator.removeAttribute('hidden');

        this.recharge.button = document.querySelector('.rb-filters-nav .rb-link');

        if (this.recharge.filters) {
          this.recharge.filters.forEach(filter => filter.removeEventListener('change', this._boundOnChange));
        }
        this.recharge.filters = Array.from(document.querySelectorAll('.rb-filter-item input[type="checkbox"]'));
        this.recharge.filters.forEach(filter => filter.addEventListener('change', this._boundOnChange));

        //Trigger URL Filters
        this.getFilterByUrl();
      }, 100)
    }

    updateAmount() {
      //Amount of active filters
      const label = this.querySelector('[data-value]')
      const actives = document.querySelectorAll('.rb-filters .rb-filter-item input[type="checkbox"][aria-checked="true"]');

      if(!label || !actives) {
        return console.error('RechargeFilters', 'no label no actives');
      }

      this.actives = actives;

      this.amount = actives.length;
      label.innerText = this.amount > 0 ? `(${this.amount})` : '';
    }

    openFilter(e) {
      e.preventDefault();
      if(!this.recharge.button) {
        console.error('RechargeFilters', 'no button')
      }

      this.recharge.button.click();
    }

    activateFilter(event) {
      const button = event.target;
      if(!button || !button.dataset.filter) {
        return console.error('RechargeFilters', 'cant find target', filter, target)
      }
      
      const { filter } = button.dataset;

      const target = document.querySelector(`.rb-filter-list input[id="${filter}"]`);
      if(!target) {
        return console.error('RechargeFilters', 'cant find target', filter, target)
      }

      const filters = this.querySelectorAll('[data-filter].active')
      filters.forEach(filter => {
        if(filter !== button) {
          filter.click();
        }
      });

      button.classList.toggle('active');
      target.click();
    }

    syncFilterButtons() {
      const buttons = this.querySelectorAll('[data-filter]');
      buttons.forEach(button => {
        const { filter } = button.dataset;
        const input = document.querySelector(`.rb-filter-list input[id="${filter}"]`);
        if (input) {
          button.classList.toggle('active', input.checked);
        }
      });
    }

    onChange(event) {
      setTimeout(() => {
        this.updateAmount();
        this.syncFilterButtons();
      }, 100);

      //Dispatch
      this.dispatchEvent();

      const params = new URLSearchParams(window.location.search);
      params.delete('filter');
      const activeFilters = this.recharge.filters.filter(input => input.checked).map(input => input.id);
      activeFilters.forEach(filter => params.append('filter', filter));
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);

    }

    getFilterByUrl() {
      const params = new URLSearchParams(window.location.search);
      const filters = params.getAll('filter');

      filters.forEach((filter) => {
        const input = document.querySelector(`li[data-rb-filter*="${filter}"] input[type="checkbox"][aria-checked="false"]`);
        if(input && typeof input !== 'undefined') {
          input.click();
          input.setAttribute("aria-checked", true);
        }

        const quick = document.querySelector(`rb-filters [data-filter="${filter}"]`)
        if(quick) {
          quick.classList.add('active');
        }
      });
    }

    dispatchEvent() {
      //Get all active Filters
      const actives = this.recharge.filters.filter(input => input.checked).map(input => input.id)
      const inactives = this.recharge.filters.filter(input => !input.checked).map(input => input.id)

      document.dispatchEvent(new CustomEvent('recharge:filter', {
        active: actives,
        inactive: inactives
      }))
    }
  }
  customElements.define('rb-filters', RechargeFilters);

  class RechargeAmount extends HTMLElement {
    connectedCallback() {
      this._boundReady = this.onRechargeReady.bind(this);
      this._boundVariant = this.onVariantChange.bind(this);
      this._boundFilter = this.onFilterChange.bind(this);
      this._boundButtonClick = this.onButtonClick.bind(this);
      this._boundProductClick = this.onProductClick.bind(this);
      this._boundClampInput = this.clampInput.bind(this);
      this._buttonListenerAttached = false;

      document.addEventListener("bundling-widget:ready", this._boundReady);
      document.addEventListener("recharge:variant", this._boundVariant);
      document.addEventListener("recharge:filter", this._boundFilter);

      this.recharge = {
        buttons: null,
        inputs: null
      }

      // Persistent qty mirror keyed by rb-item-id. Survives DOM mutations
      // (filter changes can unmount selected items while their qty stays
      // booked in Recharge's internal state). getTotals() iterates this map
      // instead of `.rb-item`, so filtered-away selections still get summed.
      this.selectedQtys = new Map();

      // Load parent product variant prices injected by the section liquid.
      // We use these for the modal total instead of relying on the widget's
      // `.rb-price` aria-label, which is sometimes filled by Recharge's own
      // hardcoded bundle pricing (XL meals) rather than this product's
      // actual Shopify variant prices.
      this.variantPrices = this.loadVariantPrices();
      this.currentVariantId = this.loadInitialVariantId();
      this.extraDiscountPct = this.loadExtraDiscount();
      this.discountCode = this.loadDiscountCode();
    }

    loadExtraDiscount() {
      // Optional campaign discount (e.g. SUMMER2026) the cart applies on top of
      // the box-tier discount. Injected by the section liquid; defaults to 0.
      const el = document.querySelector('script[data-rb-extra-discount]');
      if (!el) return 0;
      const n = parseFloat(el.textContent.trim());
      return Number.isFinite(n) && n > 0 ? n : 0;
    }

    loadDiscountCode() {
      // Optional discount code applied to the cart when this bundle is added.
      // Injected by the section liquid; empty string = inactive.
      const el = document.querySelector('script[data-rb-discount-code]');
      if (!el) return '';
      return el.textContent.trim();
    }

    applyDiscount() {
      // Apply the optional campaign code via the Cart AJAX API so it shows up in
      // the cart drawer that opens right after the add. The caller awaits this
      // BEFORE triggering the add, so the code is already on the cart token when
      // the drawer renders. Returns a promise that always resolves: on any error
      // we just move on — the add must never be blocked or fail. Applying before
      // the bundle line lands is fine; Shopify re-evaluates the code as lines change.
      const code = this.discountCode;
      if (!code) return Promise.resolve();
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).catch(() => {});
    }

    loadVariantPrices() {
      const el = document.querySelector('script[data-rb-variant-prices]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.error('RechargeAmount: failed to parse variant prices', e);
        return null;
      }
    }

    loadInitialVariantId() {
      const el = document.querySelector('script[data-rb-initial-variant]');
      if (!el) return null;
      const n = parseInt(el.textContent.trim(), 10);
      return Number.isFinite(n) ? n : null;
    }

    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this._boundReady);
      document.removeEventListener("recharge:variant", this._boundVariant);
      document.removeEventListener("recharge:filter", this._boundFilter);
    }

    onRechargeReady() {
      if (!this._buttonListenerAttached) {
        const button = this.querySelector('button');
        button.addEventListener('click', this._boundButtonClick);
        this._buttonListenerAttached = true;
      }

      setTimeout(() => {
        if (this.recharge.inputs) {
          this.recharge.inputs.forEach(input => {
            input.removeEventListener('change', this._boundProductClick);
            input.removeEventListener('input', this._boundClampInput);
          });
        }
        if (this.recharge.buttons) {
          this.recharge.buttons.forEach(button => button.removeEventListener('click', this._boundProductClick));
        }

        this.recharge.inputs = Array.from(document.querySelectorAll('.rb-item-actions input'));
        this.recharge.inputs.forEach(input => {
          input.addEventListener('change', this._boundProductClick);
          input.addEventListener('input', this._boundClampInput);
        });

        this.recharge.buttons = Array.from(document.querySelectorAll('.rb-item-actions button'));
        this.recharge.buttons.forEach(button => button.addEventListener('click', this._boundProductClick));

        // Reconcile the qty mirror with whatever's currently in the DOM.
        // Picks up restored qtys (e.g. from Recharge's saved cart) AND prunes
        // entries for items that the widget itself zeroed out.
        this.syncSelectedQtys();
      }, 200)
    }

    syncSelectedQtys() {
      // Mirror visible `.rb-input` qtys into `this.selectedQtys`.
      // We only ADD/UPDATE from DOM (not delete) because a filter may have
      // unmounted the input — its qty must remain booked in the map.
      document.querySelectorAll('.rb-item').forEach(item => {
        const id = item.dataset.rbItemId;
        if (!id) return;
        const input = item.querySelector('.rb-input');
        const qty = parseInt(input && input.value, 10) || 0;
        if (qty > 0) this.selectedQtys.set(id, qty);
        else this.selectedQtys.delete(id);
      });
    }

    trackInputQty(input) {
      // Update the qty mirror for a single input. Used by onProductClick.
      const item = input.closest('.rb-item');
      const id = item && item.dataset.rbItemId;
      if (!id) return;
      const qty = parseInt(input.value, 10) || 0;
      if (qty > 0) this.selectedQtys.set(id, qty);
      else this.selectedQtys.delete(id);
    }

    onVariantChange(event) {
      const element = this.querySelector('[data-title]');
      const progress = this.querySelector('progress');

      const { id, title, variantTitle } = event.detail;
      if(!title || !element) {
        return console.error('RechargeAmount', 'no title found')
      }

      // Track the active variant so getPrices() can pull the matching
      // Shopify variant price from the injected JSON.
      if (id) {
        const n = parseInt(id, 10);
        if (Number.isFinite(n)) this.currentVariantId = n;
      }

      //Update Element
      element.innerText = title;

      //Update Progress
      // Extract the FIRST number from the title only (e.g. "12 Tüten (1 kg)" → 12).
      // The previous `\D` strip kept every digit, including the "1" in "1 kg",
      // so 12 → 121, 18 → 181, 24 → 241, and the `progress.value === progress.max`
      // equality check never matched, so the modal never opened on those box sizes.
      progress.max = (variantTitle || title).match(/\d+/)?.[0] || progress.max;

      //Update Bars
      this.updateBars();
      
      //Re-render again
      this.onRechargeReady();
    }

    onFilterChange(event) {
      //Re-render again
      this.onRechargeReady();
    }

    onProductClick() {
      // Vue updates inputs after the click tick, so sync on the next frame.
      setTimeout(() => {
        this.syncSelectedQtys();
        this.updateBars();
        this.dispatchEvent();
      }, 0);
    }

    clampInput(event) {
      // Cap each meal input to the box's remaining capacity so users can't type
      // (e.g.) 100 into a 24-meal box. Fires on every keystroke. Dispatches
      // `change` after clamping so Recharge updates its own internal state.
      const input = event.target;
      if (!input || !input.classList.contains('rb-input')) return;

      const progress = this.querySelector('progress');
      const max = progress ? parseInt(progress.max, 10) : 0;
      if (!max || max <= 0) return;

      let sumOthers = 0;
      this.recharge.inputs.forEach(el => {
        if (el === input) return;
        sumOthers += parseInt(el.value, 10) || 0;
      });

      const remaining = Math.max(0, max - sumOthers);
      const current = parseInt(input.value, 10) || 0;
      if (current > remaining) {
        input.value = remaining;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    setLoading(loading) {
      // Brief loader on the buttons the user just pressed, so they get visual
      // feedback (and can't double-click) while the discount is applied and
      // before the modal closes / cart opens. The Recharge `.rb-btn` only gets
      // the visual class — never `disabled`, since we click it programmatically.
      const modalBtn = document.querySelector('.rb-modal-atc');
      const selfBtn = this.querySelector('button');
      [modalBtn, selfBtn].forEach(btn => {
        if (!btn) return;
        btn.classList.toggle('rb-loading', loading);
        btn.disabled = loading;
      });
      const rechargeBtn = document.querySelector('.rb-btn-wrapper .rb-btn');
      if (rechargeBtn) rechargeBtn.classList.toggle('rb-loading', loading);
    }

    async onButtonClick() {
      // Recharge widget v2 renamed `.rb-price-btn-wrapper` to `.rb-btn-wrapper`,
      // and the cart submit is `.rb-btn` (button[type="submit"]) inside it.
      const target = document.querySelector('.rb-btn-wrapper .rb-btn');
      if (!target) {
        console.error('RechargeAmount.onButtonClick: .rb-btn-wrapper .rb-btn not found');
        return;
      }

      // Apply the optional campaign code BEFORE the add, so it's already on the
      // cart when Recharge's submit opens the cart drawer. Awaited but never
      // throws (see applyDiscount), so a failed apply can't block the add. Show a
      // short loader meanwhile, then drop it right before the add fires.
      this.setLoading(true);
      await this.applyDiscount();
      this.setLoading(false);

      target.click();

      // If any filters are active, Recharge keeps the filtered-out items
      // booked internally. Unchecking all filters first re-mounts every
      // `.rb-item`, so the follow-up `clearProducts()` can zero ALL inputs
      // (visible + previously-hidden).
      const activeFilters = document.querySelectorAll(
        '.rb-filter-item input[type="checkbox"]:checked'
      );
      if (activeFilters.length > 0) {
        activeFilters.forEach(cb => {
          cb.checked = false;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        });
        // Wait for Recharge to re-render the now-unfiltered items before
        // zeroing them.
        setTimeout(() => this.clearProducts(), 250);
      } else {
        this.clearProducts();
      }
    }

    updateBars() {
      const label = this.querySelector('[data-value]')
      const progress = this.querySelector('progress');
      const button = this.querySelector('button');

      if(!label || !progress) {
        return console.error('RechargeAmount', 'no progress elements')
      }

      //Calculate everything together
      const value = this.countBooked();
      label.innerText = value;

      //Update Progress Bar
      progress.value = value;

      //Activate Button if value is max
      if(progress.value === progress.max) {
        button.removeAttribute('hidden');
      } else {
        button.hidden = true;
      }
    }

    countBooked() {
      if(document.querySelector('.rb-item-actions input')) {
        this.syncSelectedQtys();
        let sum = 0;
        this.selectedQtys.forEach(qty => sum += qty);
        return sum;
      }

      const reported = document.querySelector('[data-rb-added]');
      return reported ? parseInt(reported.dataset.rbAdded, 10) || 0 : 0;
    }

    clearProducts() {
      // Re-query from the DOM so we catch any inputs that re-mounted after
      // a filter reset; `this.recharge.inputs` may be stale.
      const allInputs = Array.from(document.querySelectorAll('.rb-item-actions input'));
      allInputs.filter(input => parseInt(input.value, 10) > 0).forEach(input => {
        input.value = 0;
        input.dispatchEvent(new Event('change'));
      });

      // Drop the qty mirror too; visible inputs were zeroed above, but
      // filtered-out items only live in the map and would otherwise persist.
      this.selectedQtys.clear();

      //Remove Cookies
      Shopify.LocalStorage.remove(cookieProducts);

      //Reset Progress — do this directly rather than via updateBars(), which reads
      //[data-rb-added] from the ReCharge Vue DOM. Vue batches DOM updates
      //asynchronously so [data-rb-added] is still stale at this point and would
      //override the reset with the old value.
      const progress = this.querySelector('progress');
      const label = this.querySelector('[data-value]');
      const button = this.querySelector('button');
      progress.value = 0;
      if (label) label.innerText = 0;
      if (button) button.hidden = true;

      //Dispatch again
      this.dispatchEvent();

      //Close Modal
      document.dispatchEvent(new CustomEvent('recharge:modal:close'))
    }

    currencyToNumber(price) {
      // Strip everything except digits and minus, so both "72.00 €" and
      // "72,00 €" yield 7200 (cents). Avoids treating decimal separators
      // as decimals across locales.
      return Number(price.replace(/[^0-9-]+/g, ''));
    }

    getTotals() {
      // Sum each SELECTED meal's per-portion price × its quantity, computed
      // independently from stable Liquid data (`data-meal-price`/`data-sub-price`),
      // never from Recharge's rendered prices. Iterates `this.selectedQtys` (the
      // persistent qty mirror) so items currently filtered out of the DOM still
      // contribute — their `[data-product]` div lives in `<rb-products>` and is
      // unaffected by Recharge's filter. Returns { price, compare } in CENTS.
      //
      // The cart applies the box-tier as a Shopify line discount: the discount
      // amount is floored per unit, so the line price is
      // `unit - Math.floor(unit × tierPercent / 100)`, NOT a rounded factor.
      // The widget's displayed `.rb-price` rounds instead, which drifts ±1 cent
      // per item vs the cart — the removed PRICE_CORRECTIONS_EUR table patched
      // exactly that. Flooring the discount here matches the real cart directly.
      // `unit` is the subscription allocation price (data-sub-price, already the
      // exact cart line base for subscriptions) or the variant price (one-time).
      if (this.selectedQtys.size === 0) return null;

      const subscribed = !!document.querySelector('rb-delivery[active]');
      const activeBtn = document.querySelector('rb-button[active]');
      const tierPct = activeBtn ? parseInt(activeBtn.getAttribute('percentage'), 10) || 0 : 0;
      const progress = this.querySelector('progress');
      const reached = !!progress && progress.max > 0 && progress.value >= progress.max;
      const tierActive = reached && tierPct > 0;

      let priceSum = 0;
      let compareSum = 0;
      let foundAny = false;

      this.selectedQtys.forEach((qty, id) => {
        if (qty <= 0) return;
        const mealDiv = document.querySelector(`[data-product="${id}"]`);
        if (!mealDiv) return;
        const baseCents = parseInt(mealDiv.dataset.mealPrice, 10) || 0;
        if (baseCents <= 0) return;
        const subCents = parseInt(mealDiv.dataset.subPrice, 10) || baseCents;
        const unit = subscribed ? subCents : baseCents;
        const lineUnit = tierActive ? unit - Math.floor(unit * tierPct / 100) : unit;
        priceSum += lineUnit * qty;
        compareSum += baseCents * qty;
        foundAny = true;
      });

      if (!foundAny) return null;

      // Apply the optional campaign discount (e.g. SUMMER2026) once on the
      // summed total, mirroring how the cart applies a code on top of the
      // box-tier discount. Floored so the modal never displays less than the
      // cart charges. `compareSum` stays the pre-discount base for strikethrough.
      let finalPrice = priceSum;
      if (this.extraDiscountPct > 0) {
        finalPrice = priceSum - Math.floor(priceSum * this.extraDiscountPct / 100);
      }

      return {
        price: finalPrice,
        compare: finalPrice === compareSum ? 0 : compareSum
      };
    }

    getPrices() {
      // Prefer the injected variant data — it reflects the parent product's
      // actual Shopify variant prices (price + compare_at_price) and is
      // immune to Recharge's hardcoded bundle pricing.
      // Returns [strikethrough_old, current_new] in CENTS, per portion.
      if (this.variantPrices && this.variantPrices.length) {
        const variant = this.variantPrices.find(v => v.id === this.currentVariantId)
                        || this.variantPrices[0];
        if (variant) {
          const price = Number(variant.price) || 0;
          const compare = Number(variant.compare_at_price) || 0;
          // No discount → return only the current price.
          if (!compare || compare === price) {
            return [0, price];
          }
          // Strikethrough is always the HIGHER number, current is the LOWER.
          // Handles both standard (compare > price) and inverted
          // (compare < price, e.g. subscription-discount convention) cases.
          return [Math.max(price, compare), Math.min(price, compare)];
        }
      }

      // Legacy fallback: read from `.rb-price` aria-label. Used only when
      // the section hasn't injected variant data (older templates).
      // Recharge widget v2 puts the aria-label on `.rb-price` itself (a <p>),
      // not on a child <span>. Fall back to old shape for backwards compat.
      const element = document.querySelector('.rb-price[aria-label]') || document.querySelector('.rb-price > span[aria-label]') || document.querySelector('.rb-price');
      if (!element) {
        return [0, 0];
      }
      const label = element.getAttribute('aria-label') || element.innerText || '';

      let prices = [0, 0]

      //Check if label contains specific wording
      if(label.includes('Original price')) {
        prices = label.split('. ').map(result => this.currencyToNumber(result));
      } else {
        prices = [0, this.currencyToNumber(element.innerText)]
      }

      return prices;
    }

    dispatchEvent() {
      const progress = this.querySelector('progress');

      //Products
      document.dispatchEvent(new CustomEvent('recharge:progress', {
        detail: {
          value: progress.value,
          max: progress.max,
          full: progress.value === progress.max,
          prices: this.getPrices(),
          // `totals` is the actual modal total in cents, summed from the
          // currently-selected meals (their `data-meal-price` × qty). Modal
          // listeners should prefer this over `prices × max` when present.
          totals: this.getTotals()
        }
      }))
    }
  }
  customElements.define('rb-amount', RechargeAmount);

  class RechargeProducts extends HTMLElement {
    connectedCallback() {
      document.addEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
      document.addEventListener("recharge:variant", this.onVariantChange.bind(this));
      document.addEventListener("recharge:filter", this.onFilterChange.bind(this));
      document.addEventListener("recharge:delivery", this.onDeliveryChange.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
      document.removeEventListener("recharge:variant", this.onVariantChange.bind(this));
      document.removeEventListener("recharge:filter", this.onFilterChange.bind(this));
      document.removeEventListener("recharge:delivery", this.onDeliveryChange.bind(this));
    }

    onRechargeReady() {
      setTimeout(() => {
        this.moveProducts();
        this.addButtons();
        this.updatePortions();
      }, 100);
    }

    onVariantChange() {
      setTimeout(() => {
        this.moveProducts();
        this.addButtons();
        this.updatePortions();
      }, 75);
    }

    onFilterChange(event) {
      setTimeout(() => {
        this.moveProducts();
        this.addButtons();
        this.updatePortions();
      }, 75);
    }

    onDeliveryChange() {
      setTimeout(() => {
        this.updatePortions();
      }, 150);
    }

    moveProducts() {
      const products = this.querySelectorAll('[data-product]');
      products.forEach(product => {
        const parent = document.querySelector(`[data-rb-item-id="${product.id}"]`);
        if(!parent) {
          return;
        }

        //Check if it has already a product
        const exists = parent.querySelector('[data-product]');
        if(exists) {
          return;
        }

        //Find target from Parent Div
        const target = parent.querySelector(`.rb-item-img`);
        if(!target) {
          return console.error('RechargeProducts', 'no item image found', product.id);
        }

        //Append
        const div = product.cloneNode(true);
        target.append(div);

        const imageBox = target.querySelector('.rb-aspect-ratio') || target;
        div.querySelectorAll('.rb-badges').forEach(badges => imageBox.append(badges));

        //Display each product
        div.removeAttribute('hidden');
      });
    }

    addButtons() {
      const buttons = document.querySelectorAll('.rb-btn-qty-plus');
      const inputs = document.querySelectorAll('.rb-input')
      buttons.forEach((button, i) => {
        if(!inputs[i]) {
          return;
        }

        const value = inputs[i].value;
        if(value === 0 || value === '0') {
          if(!button.classList.contains('rb-button-overlay')) {
            button.classList.add('rb-button-overlay');
            button.innerHTML = `<span class="tw1">+</span><span class="rb-button-atc">Hinzufügen</span>`;
          }
          if(!button.dataset.rbOverlayBound) {
            button.dataset.rbOverlayBound = '1';
            button.addEventListener('click', () => button.classList.remove('rb-button-overlay'));
          }
        }
      })
    }

    getExtraDiscountPct() {
      // Optional campaign discount (e.g. SUMMER2026), injected by the section
      // liquid. Mirrors RechargeAmount.loadExtraDiscount(); defaults to 0.
      const el = document.querySelector('script[data-rb-extra-discount]');
      if (!el) return 0;
      const n = parseFloat(el.textContent.trim());
      return Number.isFinite(n) && n > 0 ? n : 0;
    }

    updatePortions() {
      const reached = this.isActiveTierReached();
      const tierRatio = this.getTierRatio();
      const extraPct = this.getExtraDiscountPct();

      const items = document.querySelectorAll('.rb-item');
      items.forEach(item => {
        let effective;
        if(reached) {
          effective = this.getActualCents(item);
        } else {
          const baseCents = this.getBaseMealCents(item);
          const previewFactor = this.getSubscriptionFactor(item) * tierRatio;
          effective = baseCents ? Math.round(baseCents * previewFactor) : null;
        }

        // Optional campaign discount (e.g. SUMMER2026), floored like the modal
        // total. Per-portion prices floor to the portion FIRST and then apply
        // the discount — mirroring the rb-button "ab" price
        // (compare_at_price − code) — so badge and box-button stay in sync on
        // every tier (avoids ±1 cent drift on odd per-meal prices).
        const applyExtra = (cents) => (extraPct > 0 ? cents - Math.floor(cents * extraPct / 100) : cents);
        const perPortionCents = (portions) => {
          if(effective == null || portions <= 0) return null;
          // Without a campaign discount, keep the original ceil rounding so
          // pages with extra_discount = 0 are completely unaffected.
          if(extraPct <= 0) return Math.ceil(effective / portions);
          // With a discount, floor to the portion first then discount, to match
          // the rb-button "ab" price (compare_at_price − code).
          return applyExtra(Math.floor(effective / portions));
        };

        const xlBadge = item.querySelector('.rb-badge--xl');
        if(xlBadge) {
          const pp = perPortionCents(2);
          this.setBadgePrice(xlBadge, pp != null ? `| ${money.format(pp / 100)} p.P.` : null);
        }

        const premiumBadge = item.querySelector('.rb-badge--premium');
        if(premiumBadge) {
          const price = effective != null ? money.format(applyExtra(effective) / 100) : null;
          this.setBadgePrice(premiumBadge, price ? `| ${price}` : null);
        }

        const portionsBadge = item.querySelector('.rb-badge--portions');
        if(portionsBadge) {
          const portions = parseInt(portionsBadge.dataset.portions, 10) || 0;
          const pp = perPortionCents(portions);
          this.setBadgePrice(portionsBadge, pp != null ? `| ${money.format(pp / 100)} p.P.` : null);
        }
      });
    }

    getBaseMealCents(item) {
      const el = item.querySelector('[data-product]');
      const cents = el ? parseInt(el.dataset.mealPrice, 10) || 0 : 0;
      return cents > 0 ? cents : 0;
    }

    getActualCents(item) {
      const el = item.querySelector('.rb-price[aria-label]') || item.querySelector('.rb-price');
      const label = el ? (el.getAttribute('aria-label') || el.textContent || '') : '';
      const nums = label.match(/\d+[.,]\d{2}/g);
      if(!nums || !nums.length) {
        return this.getBaseMealCents(item) || null;
      }
      const actual = nums[nums.length - 1];
      return Math.round(parseFloat(actual.replace(',', '.')) * 100);
    }

    isActiveTierReached() {
      const active = document.querySelector('rb-button[active]');
      if(!active) {
        return true;
      }
      const need = parseInt((active.getAttribute('data-variant-title') || active.getAttribute('title') || '').replace(/\D/g, ''), 10) || 0;
      if(need <= 0) {
        return true;
      }
      const progress = document.querySelector('.rb-amount progress');
      const qty = progress ? parseInt(progress.value, 10) || 0 : 0;
      return qty >= need;
    }

    setBadgePrice(badge, text) {
      let el = badge.querySelector('.rb-badge-portion');
      if(!text) {
        if(el) {
          el.remove();
        }
        return;
      }
      if(el && el.textContent === text) {
        return;
      }
      if(!el) {
        el = document.createElement('span');
        el.className = 'rb-badge-portion';
        badge.appendChild(el);
      }
      el.textContent = text;
    }

    getTierRatio() {
      const activeBtn = document.querySelector('rb-button[active]');
      if(!activeBtn) {
        return 1;
      }
      const pct = parseInt(activeBtn.getAttribute('percentage'), 10) || 0;
      return 1 - (pct / 100);
    }

    getSubscriptionFactor(item) {
      if(!document.querySelector('rb-delivery[active]')) {
        return 1;
      }
      const scope = item || document;
      const el = scope.querySelector('.rb-price[aria-label]') || document.querySelector('.rb-price[aria-label]');
      const label = el ? el.getAttribute('aria-label') || '' : '';
      if(!label.includes('Original price')) {
        return 1;
      }
      const nums = (label.match(/[\d]+[.,]?\d*/g) || [])
        .map(n => parseFloat(n.replace(',', '.')))
        .filter(n => !isNaN(n) && n > 0);
      if(nums.length < 2) {
        return 1;
      }
      let ratio = nums[1] / nums[0];
      const completed = this.getCompletedTierFactor();
      if(completed > 0) {
        ratio = ratio / completed;
      }
      return (ratio > 0.4 && ratio <= 1.0001) ? Math.min(ratio, 1) : 1;
    }

    getCompletedTierFactor() {
      const progress = document.querySelector('.rb-amount progress');
      const qty = progress ? parseInt(progress.value, 10) || 0 : 0;
      let factor = 1;
      document.querySelectorAll('rb-button').forEach(btn => {
        const need = parseInt((btn.getAttribute('data-variant-title') || btn.getAttribute('title') || '').replace(/\D/g, ''), 10) || 0;
        const pct = parseInt(btn.getAttribute('percentage'), 10) || 0;
        if(need > 0 && qty >= need) {
          factor = Math.min(factor, 1 - (pct / 100));
        }
      });
      return factor;
    }

  }
  customElements.define('rb-products', RechargeProducts);

  class RechargeModal extends HTMLElement {
    constructor() {
      super();

      this.recharge = {
        products: [],
        inputs: [],
        upsell: {
          buttons: []
        }
      }
    }

    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }

    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
        this.close();
      } 
    }

    open() {
      this.detailsContainer.setAttribute('open', true);
      //document.body.classList.add('overflow-hidden');
    }

    close() {
      this.detailsContainer.removeAttribute('open');
      //document.body.classList.remove('overflow-hidden');
    }

    connectedCallback() {
      document.addEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
      document.addEventListener('recharge:progress', this.onProgressChange.bind(this));
      document.addEventListener("recharge:variant", this.onVariantChange.bind(this));
      document.addEventListener("recharge:filter", this.onFilterChange.bind(this));
      document.addEventListener("recharge:modal:open", this.open.bind(this));
      document.addEventListener("recharge:modal:close", this.close.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
      document.removeEventListener('recharge:progress', this.onProgressChange.bind(this));
      document.removeEventListener("recharge:variant", this.onVariantChange.bind(this));
      document.removeEventListener("recharge:filter", this.onFilterChange.bind(this));
      document.removeEventListener("recharge:modal:open", this.open.bind(this));
      document.removeEventListener("recharge:modal:close", this.close.bind(this));
    }

    onRechargeReady() {
      this.detailsContainer = this.querySelector('details');
      this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
      this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

      setTimeout(() => {
        this.recharge.inputs = Array.from(document.querySelectorAll('.rb-item-actions input'));
        this.recharge.inputs.forEach(input => input.addEventListener('change', this.changeCookies.bind(this)));
        
        this.recharge.buttons = document.querySelectorAll('.rb-item-actions button');
        this.recharge.buttons.forEach(button => button.addEventListener('click', this.changeCookies.bind(this)));

        this.recharge.products = Array.from(document.querySelectorAll('.rb-item'))

        this.recharge.upsell.buttons = Array.from(this.querySelectorAll('[data-upsell] button'))
        this.recharge.upsell.buttons.forEach(button => button.addEventListener('click', this.changeVariant.bind(this)));

        const submits = this.querySelectorAll('button[type="submit"]');
        submits.forEach(button => button.addEventListener('click', this.onSubmit.bind(this)));
      }, 100);
    }

    onProgressChange(event) {
      const { full, prices, max, totals } = event.detail

      //Check if the elements are openable
      if(full === true) {
        this.open();
      }

      // Prefer `totals` (in cents, already summed across selected meals).
      // This is the only way to get the correct total when the user mixes
      // meal types with different per-portion prices (regular vs XL etc.).
      const compareEl = this.querySelector('[data-compare-at-price]');
      const priceEl = this.querySelector('[data-price]');

      if (totals && totals.price > 0) {
        if (priceEl) priceEl.innerText = money.format(totals.price / 100);
        if (compareEl) compareEl.innerText = (totals.compare && totals.compare !== totals.price)
          ? money.format(totals.compare / 100)
          : '';
        return;
      }

      // Legacy fallback: per-portion price × max. Used only when getTotals()
      // returns null (no selected items / no meal data attributes available).
      if (prices) {
        const quantity = parseInt(max) || 1;
        const elements = this.querySelectorAll('[data-price], [data-compare-at-price]');
        elements.forEach((element, i) => {
          element.innerText = prices[i] ? money.format((prices[i] / 100) * quantity) : ''
        });
      }
    }

    onFilterChange() {
      // After filtering the ReCharge widget re-renders .rb-item-actions nodes,
      // so we need to re-attach changeCookies listeners to the new DOM nodes.
      setTimeout(() => this.onRechargeReady(), 100);
    }

    onVariantChange(event) {
      if(!event.detail || !event.detail.id || !event.detail.title) {
        return console.error('onVariantChange', 'no id');
      }

      //Grab Id
      const { id, title }  = event.detail;

      //Hide all other upsells
      const upsells = Array.from(this.querySelectorAll('[data-upsell]'));
      upsells.forEach(upsell => upsell.setAttribute('hidden', true));

      const upsell = upsells.find(upsell => upsell.dataset.variantId === id);
      if(upsell) {
        upsell.removeAttribute('hidden');
      }

      const headline = this.querySelector('h2[data-label]');
      if(headline) {
        headline.innerText = headline.dataset.label.replace('{{ title }}', title)
      }

      //Add back Listeners
      this.onRechargeReady();
    }

    onSubmit() {
      // Don't close immediately: the loader on the modal button needs to stay
      // visible while the discount is applied. RechargeAmount.onButtonClick()
      // closes the modal afterwards via clearProducts() → recharge:modal:close.
      const button = document.querySelector('.rb-amount button');
      button.click();
    }

    changeCookies(event) {
      const parent = event.target.closest('.rb-item');
      if(!parent) {
        return console.error('RechargeModal', 'no item', parent)
      }

      const input = parent.querySelector('.rb-input')
      const image = parent.querySelector('img');

      if(!input || !image) {
        return console.error('RechargeModal', 'missing', 'input, title, image');
      }

      //Prefer the meal image (data-cart-image), fall back to the rb-item image
      const dataProduct = parent.querySelector('[data-product]');
      const cartImage = dataProduct?.dataset.cartImage || image.src || '';

      let products = Shopify.LocalStorage.get(cookieProducts) || {};

      //Slugify name
      const name = Shopify.Slugify(input.name);
      const quantity = parseInt(input.value);

      //Check if the quantity equals 0 so we bump it up by one due to delay of inputs
      if(quantity) {
        products[name] = {
          //Prevent weird wordings
          name: encodeURIComponent(input.name),
          image: cartImage,
          quantity: parseInt(quantity),
        }
      } else {
        delete products[name];
      }

      //Set the cookies
      Shopify.LocalStorage.set(cookieProducts, products);

      //Update Layout
      this.changeProducts(products);
    }

    changeVariant(event) {
      const id = event.target.dataset.id;
      if(!id) {
        return;
      }

      const variant = document.querySelector(`rb-button[id="${id}"]`);
      variant.click();

      //Close Modal
      this.close();
    }

    changeProducts(products) {
      const product = this.querySelector('[data-products]');
      product.innerHTML = Object.values(products).map(product => {
        const name = decodeURIComponent(product.name);
        return `<div class="rb-modal-product" data-title="${name}">
            <img src="${product.image}" alt="Meal ${name}">
            <span>${product.quantity}x ${name}</span>
        </div>`;
      }).join('')
    }

  }
  customElements.define('rb-modal', RechargeModal);
})

